import React, {useEffect, useState} from 'react';
import {FormattedMessage, FormattedNumber} from 'react-intl';
import ShareBar from './cmp/ShareBar';
import {RedeemModalBody} from './pages/payments/StoreDiscountCouponAutoRedeem';
import {useDispatch, useSelector} from 'react-redux';
import {get, post, setAccessToken} from '../api';
import LoadingSkeleton from './cmp/LoadingSkeleton';
import useToggle from './cmp/hooks/useToggle';
import {actionMergeSetting} from '../redux/settings/settingsAction';
import {RenderCoupon} from './pages/payments/RenderUserPaymentSettings';
import {FiX} from 'react-icons/fi';
import RenderCommission from './cmp/RenderCommission';

function InjectStyles(){
  const refer_a_friend_config_styles = useSelector((state)=>state.settings.refer_a_friend_config?.styles)
  useEffect(()=>{
    if(refer_a_friend_config_styles){
      if(refer_a_friend_config_styles.body_backgroundColor){
        document.body.style.backgroundColor = refer_a_friend_config_styles.body_backgroundColor
      }
    }
  },[refer_a_friend_config_styles])

}
function MicroPortal(){
  return <>
    <InjectStyles />
    <MicroPortalInternal />
  </>
}

function MicroPortalInternal(){
  const [loggingIn, setLoggingIn] = useState(true)
  const [loggedIn, setLoggedIn] = useState(false)
  const searchParams = new URL(document.location.href).searchParams
  useEffect(()=>{
    if(searchParams.get('customer_id')) {
      setLoggingIn(true)
      post('/auth/refer-a-friend-login', {
          customer_id: searchParams.get('customer_id'),
          ref: searchParams.get('ref'),
        }
      ).then((data) => {
        if (data && data.access_token) {
          setAccessToken(data.access_token, true)
          setLoggedIn(true)
        }
      })
    }
  },[])
  if(!searchParams.get('customer_id')){
    if(searchParams.get('design_mode') === "true") {
      return <p className={"text-center py-4 text-danger"}>This page can only be loaded inside a logged in customer account.</p>
    }else {
      return console.log('--------- ERROR ---------\n\nNO CUSTOMER ID\n\n--------- ERROR ---------');
    }
  }
  return loggedIn ? <PortalContent/> : <div className="container-fluid mt-2">
    <div className={"row row-cols-2"}>
       <div className="col-md-6"><LoadingSkeleton height={140}/></div>
      <div className="col-md-6"><LoadingSkeleton height={140} /></div>
    </div>
  </div>
}



function PortalContent(props) {
  const referral_link = useSelector((state)=>state.settings.referral_link)
  const [visible, toggle] = useToggle()
  const [loading, setLoading] = useState(false)
  const [payments, setPayments] = useState(null)
  const dispatch = useDispatch()
  useEffect(()=>{
    setLoading(true)
    Promise.all([
        get('/').then((data)=> {
          dispatch(actionMergeSetting(data.settings))
        }),
        get('/payments')
          .then((data)=>{
            setPayments(data)

        })
    ]).then(()=>{
       setLoading(false)
    })
  },[])
  const [redeem_amount, setRedeemAmount] = useState(0);
  const vouchers = payments?.data.filter(({payment_method})=>payment_method === "discountcoupon");

  return (
      <div className={"container-fluid"} style={{paddingTop:8, paddingBottom:24}}>
        <div className="row py-4">
          <div className="col-md-6 mb-2">
            <div className="card">
              <div className="card-body">
                <h3>Referral Link</h3>
                <a href={referral_link} target={"_top"}>{referral_link}</a>
                <ShareBar link={referral_link} />
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-2 d-flex">
            {
              visible ? <div className="card flex-fill">
                <div className="card-body position-relative">
                  <button onClick={toggle}
                          style={{top:0, right:0, position:'absolute'}}
                          className={'btn m-1 position-absolute top-0 right-0 btn-link text-secondary'}><FiX /></button>
                  <h3>Redeem Points</h3>
                  <RedeemModalBody redeem_amount={redeem_amount} onChange={setRedeemAmount} />
                </div>
              </div>:
              <div className="card flex-fill">
                <div className="card-body">
                  {
                    loading ? <LoadingSkeleton height={35} /> :
                    <div className="d-flex space-between ">
                      <h2>
                        {
                          loading ? <LoadingSkeleton height={12} />:
                              <FormattedNumber value={payments?.amount_pending || 0} />
                        }
                      </h2>
                      {
                        !loading && payments?.amount_pending > 0 ?
                          <button className="btn btn-link" onClick={toggle}>Redeem</button> : null
                      }
                    </div>
                  }
                  <div className="d-flex space-between">
                    <span>Your points</span>

                  </div>
                </div>
              </div>
            }
         </div>
        </div>
        {
          vouchers?.length > 0 ? <>
            <h3>My Vouchers</h3>
            <div className="row flex-wrap row-gap-4">
              {
                vouchers.map((i)=>{
                  const payment_details_obj = JSON.parse(i.payment_details_data || '{}');
                  const coupon = payment_details_obj?.coupon_data;
                  return <div className={"col-md-4"} key={String(i.payout_id)}>
                      <div className="card">
                        <div className="card-body">
                          <h4>
                            <FormattedMessage id={coupon?.discount_type === "free_shipping" ? "Free shipping" : "coupon_code_discount"}
                                              defaultMessage={'{discount_value} off'} values={
                              {
                                discount_value: <RenderCommission commission_value={coupon?.discount_value || coupon?.discount_amount || 0}
                                                                  commission_type={coupon?.discount_type}
                                />
                              }
                            }
                            />
                          </h4>
                          <RenderCoupon payment_details_obj={payment_details_obj} />
                        </div>
                      </div>
                  </div>
                })
              }
            </div>
          </> : null
        }
      </div>
  );
}

export default MicroPortal;
